import React, { ReactElement } from 'react';
import { Box, UpdateAvailable } from '@cherre-frontend/ui';

const ConnectorCardUpdateAvailableLogo: React.FC = (): ReactElement => {
  return (
    <Box style={{ paddingTop: '8px' }}>
      <UpdateAvailable
        style={{ color: '#FF9B04', height: '35px', width: '35px' }}
      />
    </Box>
  );
};

export default ConnectorCardUpdateAvailableLogo;
